module.exports = __webpack_public_path__ + "img/Vector-bottom rotated.1a9ff28b.svg";